import script from "./CCheckpoint.vue?vue&type=script&setup=true&lang=js"
export * from "./CCheckpoint.vue?vue&type=script&setup=true&lang=js"

import "./CCheckpoint.vue?vue&type=style&index=0&id=9c39b1fe&lang=scss"

const __exports__ = script;

export default __exports__